// extracted by mini-css-extract-plugin
export var blurimage = "Blur-module--blurimage--R0Ukc";
export var imagediv = "Blur-module--imagediv--Yka1x";